import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Chip,
  Button,
} from "@mui/material";

import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const features = [
  {
    icon: <AutoAwesomeOutlinedIcon />,
    title: "Increase Brand Visibility",
  },
  {
    icon: <RocketLaunchOutlinedIcon />,
    title: "Get More Orders",
  },
  {
    icon: <LocationOnOutlinedIcon />,
    title: "Reach Nearby Customers",
  },
  {
    icon: <RepeatOutlinedIcon />,
    title: "Improve Repeat Customers",
  },
  {
    icon: <FlashOnOutlinedIcon />,
    title: "Promote Offers Instantly",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Generate Leads Automatically",
  },
  {
    icon: <PsychologyOutlinedIcon />,
    title: "AI Audience Targeting",
  },
  {
    icon: <BarChartOutlinedIcon />,
    title: "Real-Time Analytics",
  },
];

const stats = [
  {
    title: "Reach",
    value: "+300%",
    growth: "+42%",
    icon: <TrendingUpOutlinedIcon />,
    color: "#FF8A00",
  },
  {
    title: "Orders",
    value: "+120%",
    growth: "+18%",
    icon: <RocketLaunchOutlinedIcon />,
    color: "#32D583",
  },
  {
    title: "Repeat Customers",
    value: "+85%",
    growth: "+9%",
    icon: <RepeatOutlinedIcon />,
    color: "#1FB6FF",
  },
  {
    title: "Conversion Rate",
    value: "+65%",
    growth: "+12%",
    icon: <TrendingUpOutlinedIcon />,
    color: "#111827",
  },
];

const PromotionFeaturesgroth = ({ onGetStarted }) => {
  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        // bgcolor: "#f8fafc",
      }}
    >
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          width: "100%",
          maxWidth: "100%",
          px: {
            xs: 2,
            sm: 3,
            md: 4,
            lg: 5,
            xl: 6,
          },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, md: 4 },
            borderRadius: "28px",
            border: "1px solid #e5e7eb",
            bgcolor: "#fff",
          }}
        >
          <Chip
            label="WHY MAAMAAS PROMOTE"
            sx={{
              bgcolor: "#FFF4E8",
              color: "#FF8A00",
              fontWeight: 700,
              fontSize: "0.65rem",
              mb: 2,
            }}
          />

          <Typography
            variant="h4"
            fontWeight={800}
            sx={{
              mb: 4,
              fontSize: {
                xs: "1.5rem",
                sm: "1.8rem",
                md: "2.2rem",
              },
            }}
          >
            How This Module Helps Vendors Grow
          </Typography>

          {/* Features */}
          <Grid container spacing={2}>
            {features.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    borderRadius: "20px",
                    border: "1px solid #ececec",
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    transition: ".3s",
                    height: "100%",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 15px 40px rgba(0,0,0,.08)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 42,
                      height: 42,
                      borderRadius: "50%",
                      bgcolor: "#FFF4E8",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#FF8A00",
                      flexShrink: 0,
                    }}
                  >
                    {React.cloneElement(item.icon, { sx: { fontSize: "1.2rem" } })}
                  </Box>

                  <Typography
                    fontWeight={700}
                    sx={{
                      fontSize: {
                        xs: "0.8rem",
                        md: "0.9rem",
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* Stats Cards */}
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {stats.map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2.5,
                    borderRadius: "20px",
                    border: "1px solid #ececec",
                    transition: ".3s",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 15px 40px rgba(0,0,0,.08)",
                    },
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={1.5}
                  >
                    <Typography
                      sx={{
                        color: "#64748B",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        fontSize: "0.7rem",
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "50%",
                        bgcolor: `${item.color}20`,
                        color: item.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {React.cloneElement(item.icon, { sx: { fontSize: "1.1rem" } })}
                    </Box>
                  </Box>

                  <Typography
                    fontWeight={800}
                    sx={{
                      fontSize: {
                        xs: "1.5rem",
                        md: "2rem",
                      },
                    }}
                  >
                    {item.value}
                  </Typography>

                  <Chip
                    label={`↗ ${item.growth}`}
                    sx={{
                      mt: 1.5,
                      bgcolor: "#DCFCE7",
                      color: "#16A34A",
                      fontWeight: 700,
                      fontSize: "0.7rem",
                      height: 24,
                    }}
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper>

        {/* CTA Section */}
        <Paper
          elevation={0}
          sx={{
            mt: 4,
            borderRadius: "30px",
            overflow: "hidden",
            background:
              "linear-gradient(135deg,#071A3D 0%, #182B63 50%, #8A4B31 100%)",
            p: { xs: 3, md: 5 },
          }}
        >
          <Grid
            container
            spacing={3}
            alignItems="center"
            justifyContent="space-between"
          >
            <Grid item xs={12} md={8}>
              <Typography
                fontWeight={800}
                color="#fff"
                sx={{
                  fontSize: {
                    xs: "1.5rem",
                    md: "2.2rem",
                  },
                }}
              >
                Launch your first AI-optimised campaign today
              </Typography>

              <Typography
                sx={{
                  mt: 1.5,
                  color: "rgba(255,255,255,.8)",
                  fontSize: "0.95rem",
                }}
              >
                Pick a goal, set a budget, hit launch. We'll handle the rest.
              </Typography>
            </Grid>

            {/* <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "flex-start",
                    md: "flex-end",
                  },
                }}
              >
                <Button
                  endIcon={<ArrowForwardIcon />}
                  onClick={onGetStarted}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: "14px",
                    bgcolor: "#FF8A00",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "0.9rem",
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "#f97316",
                    },
                  }}
                >
                  Get Started
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default PromotionFeaturesgroth;